export default "__VITE_ASSET__BMJxd7QP__"